/* Quick-add v2 — progressive-disclosure add-to-cart for collection cards.
   Generic over product options: handles color+size, size-only, color-only, and
   single-variant products. A "Color" option renders as swatches; every other
   option (Size, Style, etc.) renders as pills. Availability cross-filters as you
   choose. Wrapped in try/catch per card so it can never break the page.
   Activated only in the v2 bucket (html.qa-v2 for live A/B, or .qa-v2 wrapper for
   the ?view=v2 preview). Vanilla JS. */
(function () {
  "use strict";

  var COLORS = {
    "white": "#F9F9F9", "lime-green": "#AAF55F", "army-green": "#6F7F28", "navy-blue": "#204677",
    "tan": "#E8CAA5", "blue": "#005BD3", "yellow": "#FFE500", "green": "#05AA3D", "red": "#F61F1F",
    "orange": "#FF8A00", "grey": "#A7A7A7", "cream": "#F2ECD3", "light-brown": "#C57411",
    "khaki": "#E0B581", "charcoal": "#595858", "pink": "#FDC7D0", "chocolate-brown": "#6A3318",
    "lavender": "#EACDFF", "sage-green": "#2B5F31", "black": "#000000", "baby-blue": "#7DCBF8"
  };
  function handleize(s) { return (s == null ? "" : String(s)).toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, ""); }
  function colorHex(v) { var h = handleize(v); return COLORS[h] || COLORS[h.split("-")[0]] || "#dcdcdc"; }
  function isColorName(n) { return /colou?r/i.test(n || ""); }
  function vOpt(v, i) { return i === 0 ? v.o1 : i === 1 ? v.o2 : v.o3; }

  function updateCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var sels = ".cart-count,[data-cart-count],.cart-count-bubble,#CartCount,.header__cart-count,.cart-link__count,.site-header__cart-count";
        document.querySelectorAll(sels).forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
  }

  function build(card) {
    try {
      var pid = card.getAttribute("data-product-id");
      var data = (window.QA_PRODUCTS || {})[pid];
      if (!data || !data.variants || !data.variants.length) return;
      var host = card.querySelector(".product-title") || card;
      if (host.querySelector(".qa")) return;

      var opts = data.options || [];
      var single = data.variants.length === 1;
      // distinct values per option, in variant order
      var optionValues = opts.map(function (_n, i) {
        var seen = {}, vals = [];
        data.variants.forEach(function (v) { var val = vOpt(v, i); if (val != null && !seen[val]) { seen[val] = 1; vals.push(val); } });
        return vals;
      });
      var state = opts.map(function () { return null; });

      var wrap = document.createElement("div"); wrap.className = "qa";
      var toggle = document.createElement("button");
      toggle.type = "button"; toggle.className = "qa-toggle";
      toggle.innerHTML = '<span class="qa-plus">+</span> Add to cart';
      wrap.appendChild(toggle);

      var panel = document.createElement("div"); panel.className = "qa-panel";
      var head = document.createElement("div"); head.className = "qa-head";
      var headLabel = document.createElement("span"); headLabel.className = "qa-head-label"; headLabel.textContent = single ? "Add one" : "Select options";
      var collapse = document.createElement("button"); collapse.type = "button"; collapse.className = "qa-collapse"; collapse.setAttribute("aria-label", "Collapse"); collapse.textContent = "−";
      head.appendChild(headLabel); head.appendChild(collapse); panel.appendChild(head);

      // a row per option (rendered only if >1 distinct value, OR it's the lone option)
      var rows = [];
      opts.forEach(function (name, i) {
        if (optionValues[i].length <= 1 && opts.length > 1) return; // skip a fixed option in a multi-option product
        var labelEl = document.createElement("div"); labelEl.className = "qa-label"; labelEl.textContent = name;
        var row = document.createElement("div"); row.className = isColorName(name) ? "qa-swatches" : "qa-sizes";
        panel.appendChild(labelEl); panel.appendChild(row);
        rows.push({ i: i, name: name, isColor: isColorName(name), el: row });
      });

      var addBtn = document.createElement("button"); addBtn.type = "button"; addBtn.className = "qa-add"; addBtn.textContent = "Add to cart"; addBtn.disabled = true;
      panel.appendChild(addBtn);
      var msg = document.createElement("div"); msg.className = "qa-msg"; panel.appendChild(msg);
      wrap.appendChild(panel); host.appendChild(wrap);

      function variantMatches(v, exceptIdx) {
        for (var j = 0; j < opts.length; j++) {
          if (j === exceptIdx) continue;
          if (state[j] != null && vOpt(v, j) !== state[j]) return false;
        }
        return true;
      }
      function valueAvailable(i, val) {
        return data.variants.some(function (v) { return vOpt(v, i) === val && v.available && variantMatches(v, i); });
      }
      function renderRow(row) {
        row.el.innerHTML = "";
        optionValues[row.i].forEach(function (val) {
          var avail = valueAvailable(row.i, val);
          var b = document.createElement("button");
          b.type = "button";
          b.setAttribute("data-oi", row.i); b.setAttribute("data-val", val);
          if (row.isColor) {
            b.className = "qa-swatch" + (avail ? "" : " soldout"); b.title = val; b.style.background = colorHex(val);
          } else {
            b.className = "qa-size" + (avail ? "" : " disabled"); b.textContent = val; if (!avail) b.disabled = true;
          }
          if (state[row.i] === val) b.classList.add("sel");
          row.el.appendChild(b);
        });
      }
      function renderAll() { rows.forEach(renderRow); }
      function resolve() {
        return data.variants.filter(function (v) {
          for (var j = 0; j < opts.length; j++) { if (state[j] != null && vOpt(v, j) !== state[j]) return false; }
          return true;
        })[0];
      }
      function allChosen() { return rows.every(function (row) { return state[row.i] != null; }); }
      function refreshAdd() { var v = allChosen() ? resolve() : null; addBtn.disabled = !(v && v.available); }
      function swapImage() {
        var ci = -1; for (var k = 0; k < rows.length; k++) if (rows[k].isColor) ci = rows[k].i;
        if (ci < 0) return;
        var iv = data.variants.filter(function (v) { return vOpt(v, ci) === state[ci] && v.img; })[0];
        if (iv && iv.img) { var img = card.querySelector(".collection-image"); if (img) img.src = iv.img; }
      }

      renderAll();

      toggle.addEventListener("click", function () {
        if (single) { addToCart(data.variants[0].id); wrap.classList.add("open"); return; }
        // if every option has only one value, just add the single resolvable variant
        if (!rows.length) { var v0 = resolve(); if (v0) addToCart(v0.id); wrap.classList.add("open"); return; }
        wrap.classList.add("open");
      });
      collapse.addEventListener("click", function () { wrap.classList.remove("open"); });

      panel.addEventListener("click", function (e) {
        var b = e.target.closest("[data-oi]");
        if (!b || b.classList.contains("soldout") || b.disabled) return;
        var i = +b.getAttribute("data-oi");
        state[i] = b.getAttribute("data-val");
        renderAll(); refreshAdd();
        if (rows.length && rows.filter(function (r) { return r.i === i; })[0].isColor) swapImage();
      });
      addBtn.addEventListener("click", function () { var v = resolve(); if (v && v.available) addToCart(v.id); });

      function openThemeDrawer() {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (typeof window.updateCartUI === "function") window.updateCartUI(cart); else updateCartCount();
            var d = document.getElementById("cart-drawer");
            if (typeof window.toggleCart === "function" && d && d.getAttribute("aria-hidden") !== "false") window.toggleCart();
            else if (!d || typeof window.toggleCart !== "function") { msg.className = "qa-msg ok"; msg.innerHTML = 'Added ✓ &nbsp;<a href="/cart">View cart →</a>'; }
          }).catch(function () { updateCartCount(); });
      }
      function addToCart(id) {
        addBtn.disabled = true; msg.className = "qa-msg"; msg.textContent = "Adding…";
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok) { msg.className = "qa-msg ok"; msg.textContent = "Added ✓"; wrap.classList.remove("open"); openThemeDrawer(); }
            else { msg.className = "qa-msg err"; msg.textContent = (res.j && res.j.description) || "Couldn’t add — try the product page"; refreshAdd(); }
          }).catch(function () { msg.className = "qa-msg err"; msg.textContent = "Network error"; refreshAdd(); });
      }
    } catch (err) { /* never break the page */ }
  }

  function run() { try { document.querySelectorAll(".qa-v2 .collection-product[data-product-id]").forEach(build); } catch (e) {} }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
